import * as R from 'ramda';


export default function BackofficeUser(data) {
    //const statusOptions = { notAccepted: "n'a pas accepté", ongoing: "en cours", finished: "terminé", oneYearContract: "contrat d'un an" };
    let statusOptions;

    let user = data || {};
    let professions = [];
    if (!Array.isArray(user.professionalSituation)) {
        if (!R.isNil(user.professionalSituation) && user.professionalSituation !== "" && !Number.isInteger(user.professionalSituation) && user.professionalSituation !== 0 && user.professionalSituation !== "0") {
            let allProfs = user.professionalSituation.split(',');
            if (Array.isArray(allProfs)) {
                allProfs.forEach(p => { professions.push(p.trim()); });
            }
            else {
                professions.push(allProfs);
            }
        }
    }


    let userStatus = user.createdByRepresentative ? user.isSerenita ? getSerenitaStatus(user) : getFacilitaStatus(user) : getAntecipaStatus(user);

    this.id = user.id;
    this.email = user.email;
    this.emailConfirmed = user.emailConfirmed;
    this.phoneNumber = user.phoneNumber;
    this.gender = user.gender === '0' ? undefined : user.gender;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.birthDate = R.isNil(user.birthDate) || user.birthDate === '0001-01-01T00:00:00Z' ? undefined : new Date(user.birthDate);
    this.birthPlace = user.birthPlace;
    this.departmentNumber = R.isNil(user.departmentNumber) ? "" : user.departmentNumber;
    this.country = R.isNil(user.country) ? "FR" : user.country;
    this.civilStatus = user.civilStatus === '0' ? undefined : user.civilStatus;
    this.hasChildren = user.hasChildren;
    this.professionalSituation = professions;
    this.processNumber = user.processNumber;
    this.hasRepresentativeMessage = user.hasRepresentativeMessage;
    this.onBoardingStep = user.onBoardingStep;
    this.setupCompletedDate = user.setupCompletedDate === '0001-01-01T00:00:00Z' || user.setupCompletedDate === null || user.setupCompletedDate === undefined ? undefined : new Date(user.setupCompletedDate);
    this.creationDate = user.creationDate === '0001-01-01T00:00:00Z' || user.creationDate === null || user.creationDate === undefined ? undefined : new Date(user.creationDate);
    this.stripeCustomerId = user.stripeCustomerId;
    this.removeSetupFee = user.removeSetupFee;
    this.paymentMethods = R.isNil(user.paymentMethods) ? [] : user.paymentMethods;
    this.billedByPartner = user.billedByPartner;
    this.etablissementId = user.etablissementId;
    this.partnerId = user.partnerId;
    this.daysOfTraining = user.daysOfTraining;
    this.isEnabled = R.isNil(user.isEnabled) ? true : user.isEnabled;
    this.isEtablissementAdmin = R.isNil(user.isEtablissementAdmin) ? true : user.isEtablissementAdmin;
    this.childrens = R.isNil(user.childrens) ? [] : user.childrens;
    this.status = userStatus;
    this.createdByRepresentative = data.createdByRepresentative;
    this.roles = R.isNil(user.roles) ? [] : user.roles.map(u => u.toLowerCase());
    this.isDeceased = user.isDeceased;
    this.toDeleteDate = user.toDeleteDate === '0001-01-01T00:00:00Z' || R.isNil(user.toDeleteDate) ? undefined : new Date(user.toDeleteDate);
    this.onBoardingCompletedDate = R.isNil(user.onBoardingCompletedDate) || user.onBoardingCompletedDate === '0001-01-01T00:00:00Z' ? undefined : new Date(user.onBoardingCompletedDate);
    this.hasPendingInvoice = user.hasPendingInvoice;
    this.pendingInvoiceId = user.pendingInvoiceId;
    this.hasHrDocuments = user.hasHrDocuments;
    this.hasDocumentSending = user.hasDocumentSending;
    this.isSerenita = user.isSerenita;
    this.creationUser = R.isNil(user.creationUser) ? "" : `${user.creationUser.firstName} ${user.creationUser.lastName}`
    this.creationUserId = R.isNil(user.creationUser) ? undefined : user.creationUser.id
    this.selfcareId = user.selfcareId;
}


function getFacilitaStatus(data) {

    let statusOptions = { notStarted: "notStarted", notAccepted: "notAccepted", ongoing: "ongoing", sending: "sending", overtime: "overtime", archived:"archived"  };
    let userStatus = statusOptions.ongoing;
    if(data.onBoardingStep == 0){
        userStatus = statusOptions.notStarted;
    }
    if (data.onBoardingStep > 0 && R.isNil(data.setupCompletedDate)) {
        userStatus = statusOptions.notAccepted;
    }
    if (data.isDeceased) {
        userStatus = statusOptions.sending;
    }
    if (data.hasLettersToBeSentOvertime) {
        userStatus = statusOptions.overtime;
    }
    if(!data.isEnabled){
        userStatus = statusOptions.archived;
    }
    return userStatus;
};

function getSerenitaStatus(data) {

    let statusOptions = { notAccepted: "notAccepted", ongoing: "ongoing", sending: "sending", overtime: "overtime" };

    let userStatus = statusOptions.ongoing;
    if (R.isNil(data.setupCompletedDate)) {
        userStatus = statusOptions.notAccepted;
    }
    if (data.isDeceased) {
        userStatus = statusOptions.sending;
    }
    if (data.hasLettersToBeSentOvertime) {
        userStatus = statusOptions.overtime;
    }

    return userStatus;
};


function getAntecipaStatus(data) {

    let statusOptions = { notAccepted: "notAccepted", ongoing: "ongoing", finished: "finished", yearAndMore: "yearAndMore", closed: "closed" };

    const currentDate = new Date();
    const paymentLimit = new Date(data.creationDate);
    paymentLimit.setFullYear(paymentLimit.getFullYear() + 1);
    while(paymentLimit < currentDate){
        paymentLimit.setFullYear(paymentLimit.getFullYear() + 1);
    }

    const paymentAlertLimit = new Date(paymentLimit).setMonth(paymentLimit.getMonth() - 2);

    let userStatus = statusOptions.notAccepted;

    if (!R.isNil(data.toDeleteDate)) {
        userStatus = statusOptions.closed;
    } else if (data.onBoardingStep < 6 || R.isNil(data.onBoardingStep)) {
        userStatus = statusOptions.notAccepted;

    }else if (currentDate >= paymentAlertLimit && currentDate < paymentLimit){
        userStatus = statusOptions.yearAndMore;
    } else if (!R.isNil(data.setupCompletedDate)) {
        userStatus = statusOptions.finished;
    }else {
        userStatus = statusOptions.ongoing;
        //userStatus = statusOptions.finished;
    }



    return userStatus;
};